<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!--<div class="o-registerInfo d-md-flex align-items-center d-none mr-4">
            <div class="m-registerInfo__description d-none d-lg-block">
                <p class="mb-0">Ako to funguje?</p>
            </div>
            <div class="m-registerInfo__btn ml-3">
                <a target="_blank" href="https://adoptujkravicku.sk/pravidla-pouzivania/" class="btn --primary">Pravidlá hry</a>
            </div>
        </div>-->

        <!-- Main -->
        <main class="registerScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"></div>

                    <!-- Adopcia -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol">

                        <!-- Breadcrumb -->
                        <ol class="m-stepNavigation">
                            <li class="a-stepNavigation__item is-done mb-2 mb-md-0">VÝBER KRAVIČKY</li>
                            <li class="a-stepNavigation__item is-done mb-2 mb-md-0">ÚDAJE KRAVIČKY</li>
                            <li class="a-stepNavigation__item is-active">EAN KÓDY</li>
                        </ol>

                        <div class="paddingBox">
                            <h2>Zadanie EAN kódov</h2>

                            <!-- Alert box -->
                            <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                                <span :class="'icon --'+responseType"></span>{{ responseText }}
                            </div>

                            <div class="row">
                                <div class="col-lg-7 col-xl-7">

                                    <!-- Počet kódov -->
                                    <div class="o-widget --lightBg --small --rounded d-flex mb-4 justify-content-between">
                                        <div class="m-widget__text">Potrebných k adopcii</div>
                                        <div class="m-widget__codes" id="codes_remaining">
                                            {{ remaining_codes }}

                                            <!-- Skloňovanie -->
                                            <span v-if="remaining_codes == 1">
                                                kód
                                            </span>
                                            <span v-else-if="remaining_codes > 1 && remaining_codes < 5">
                                                kódy
                                            </span>
                                            <span v-else>
                                                kódov
                                            </span>
                                            <!-- .Skloňovanie -->

                                        </div>
                                    </div>

                                    <!-- Form Box -->
                                    <form @submit="formSubmit">
                                        <div class="form-row">
                                            <div class="col-12 col-md-12">
                                                <label for="ean-kod">
                                                    EAN kód
                                                    <a id="popoverEan" class="float-right mr-4">Kde nájdem EAN kód?</a>
                                                    <b-popover target="popoverEan" triggers="click" placement="top">
                                                        <template slot="title">Kde ho nájdem?</template>
                                                        <div class='text-center'><p>Kódy EAN sa používajú na označovanie tovaru.<br> Nájsť ich môžeš na obaloch produktov.</p><p><img src='https://www.adoptujkravicku.sk/hra/dist/images/content/ean-kod.jpg'></p></div>
                                                    </b-popover>
                                                </label>
                                                <input type="text" class="form-control" v-model="ean_code">
                                                <a href="https://www.adoptujkravicku.sk/mobilna-aplikacia-adoptuj-kravicku-skener/" class="float-right mr-2 mt-1 extenralLink">
                                                    Skenujte kódy pomocou aplikácie<span class="icon"></span>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="col-12 col-md-12">
                                                <button :disabled="isDisabled" id="codes_remaining_button" class="btn --primary w-100 mb-2">
                                                    Pridať ean kód 1/1<span class="icon --barcodeIcon"></span>
                                                </button>
                                                <router-link :to="{ name: 'kravicky' }" id="codes_remaining_button" class="btn --secondary w-100">
                                                    Prejsť do hry
                                                </router-link>
                                            </div>
                                        </div>
                                    </form>
                                    <!-- .Form Box -->

                                </div>

                                <!-- Benefity -->
                                <div class="col-lg-5 col-xl-5">
                                    <aside class="o-widget mb-md-5">
                                        <div class="m-widgetContent">
                                            <div class="m-widgetContent__description">
                                                <p>EAN kódy získavate zakúpením produktov Slovenskej Mliečnej Rodiny. Kravička vám bude automaticky rezervovaná po dobu 10 dní. K zadávaniu EAN kódov s môžete kedykoľvek vrátiť.</p>
                                            </div>

                                            <strong>Tvoje už vložené kódy:</strong>
                                            <span v-for="(item, index) in ean_codes">
                                                {{ item.ean_code }}<br>
                                            </span>
                                        </div>

                                        <div v-if="!isDisabled" class="separator"></div>
                                        <div v-if="!isDisabled" class="m-widgetContent">
                                            Kravička je rezervovaná ešte<br>
                                            <strong class="--colorOrange">
                                                {{ remaining_days }}

                                                <!-- Skloňovanie -->
                                                <span v-if="remaining_days == 1">
                                                    deň
                                                </span>
                                                <span v-else-if="remaining_days > 1 && remaining_days < 5">
                                                    dni
                                                </span>
                                                <span v-else>
                                                    dní
                                                </span>
                                                <!-- .Skloňovanie -->

                                            </strong>
                                        </div>
                                    </aside>
                                </div>
                                <!-- .Benefity -->

                            </div>
                        </div>
                    </div>
                    <!-- .Adopcia -->

                </div>
            </div>

            <b-modal id="modalUspesnaAdopcia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLostPasswordTitle" aria-hidden="true" ref="modalUspesnaAdopcia">

                <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalUspesnaAdopcia')"><span class="icon"></span></b-button>

                <div class="modal-body o-modalInfo">

                    <div class="m-modalLostPassword__content text-center">
                        <img class="img-fluid mb-3" src="assets/img/checkCircle.png" alt="">
                        <h2 class="m-modalLostPassword__name text-center">Výborne! Adoptoval si si novú kravičku</h2>
                        <p class="text-center">Splnil si potrebný limit EAN kódov na adopciu tvojej kravičky. Na tvoj e-mail sme ti poslali jej rodný list. Zadané EAN kódy boli premenené na dukáty, ktoré využiješ v hre. Prajeme veľa zábavy.</p>
                        <div class="text-center mb-2">
                            <router-link :to="{ name: 'kravicky' }" class="btn --primary">Prejsť do hry</router-link>
                        </div>
                        <div class="text-center">
                            <a :href="'https://adoptujkravicku.sk/hra/kravicka/rodny-list/' + kravicka_id" class="btn --secondary" target="_blank">Rodný list kravičky</a>
                        </div>
                    </div>

                </div>

            </b-modal>

        </main>
        <!-- .Main -->

    </div>

</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    export default {
        components: {
            HeaderProfil
        },
        props: [
            'profil'
        ],
        mounted() {
            this.getKravickaId()
            this.getKravickaData()
            this.getEanCodes()
        },
        data() {
            return {
                kravicka_id: '',

                kravicka_rezervacia: '',
                kravicka_dvor_id: '',
                remaining_days: '',
                remaining_codes: '',
                ean_code: '',
                ean_codes: '',

                isDisabled: false,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getKravickaId() {
                if ( this.$route.params.kravicka_id ) {
                    this.kravicka_id = this.$route.params.kravicka_id
                }

                if ( !this.kravicka_id ) {
                    this.$router.push({ name: 'login' })
                }
            },

            getKravickaData() {
                EventService.getKravickaData(this.$route.params.kravicka_id)
                    .then(response => {
                        //console.log(response.data)
                        this.kravicka_dvor_id    = response.data.data[0].dvor_id.id
                        this.kravicka_rezervacia = response.data.data[0].kravicka_zaciatok_adopcie
                        this.getAdoptionInfo(this.kravicka_rezervacia)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            getEanCodes() {
                EventService.getEanCodes(this.$route.params.kravicka_id, 'adoption')
                    .then(response => {
                        //console.log(response.data)
                        this.ean_codes = response.data.data
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            getAdoptionInfo(zaciatok_adopcie) {
                // today date format
                var date1 = EventService.getCurrentDate(0)
                var d1 = date1.split("-")
                var today = new Date(d1[0], d1[1], d1[2])

                // zaciatok adopcie date format
                var date2 = zaciatok_adopcie.split(" ")
                var d2 = date2[0].split("-")
                var adopcia = new Date(d2[0], d2[1], d2[2])

                // rozdiel v dňoch
                var diff = new Date(today.getTime() - adopcia.getTime());
                var days = diff.getUTCDate() - 1;

                this.remaining_days = 10 - days

                EventService.getGlobalSettings('ean_adoption_count')
                    .then(response => {
                        //console.log(response.data)
                        // unserialize: 'a:2:{i:0;i:1;i:1;i:5;}'

                        /*var a = response.data.data[0].param_value
                        var b = a.replace("a:2:{i:", "").replace(";}", "")
                        var c = b.split(";i:")*/
                        var c = response.data.data[0].param_value.replace("a:2:{i:", "").replace(";}", "").split(";i:")

                        var required = 0
                        if (this.profil.pouzivatel_id.pouzivatel_group == 0) {
                            required = c[1] - this.ean_codes.length
                        } else {
                            required = c[3] - this.ean_codes.length
                        }
                        if (required < 0) {
                            this.responseType = 'success'
                            this.responseText = 'Gratulujeme, kravička bola úspešne adoptovaná'
                            this.isDisabled = true
                            required = 0
                            this.$refs['modalUspesnaAdopcia'].show()
                        }
                        this.remaining_codes = required
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.eanExchange()
            },

            eanExchange() {
                if (this.ean_code != '') {
                    EventService.eanExchange('adoption', this.profil.pouzivatel_id.pouzivatel_group, this.kravicka_dvor_id, this.ean_code, this.$route.params.kravicka_id, this.profil.pouzivatel_id.id, this.profil.pouzivatel_id.pouzivatel_name, this.profil.pouzivatel_email)
                        .then(response => {
                            //console.log(response.data)
                            this.responseType = response.data.code
                            this.responseText = response.data.data

                            if (response.data.code == 'success') {
                                this.$refs['modalUspesnaAdopcia'].show()

                                this.ean_codes.push({ean_code: this.ean_code})
                                this.remaining_codes -= 1
                                this.ean_code = ''
                                for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                                    if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id == this.$route.params.kravicka_id) {
                                        this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_status = '2'
                                    }
                                }
                                this.$emit('update:profil', this.profil)

                                this.$gtm.trackEvent({
                                    event: 'Adoption',
                                    category: 'form',
                                    action: 'submit',
                                    label: 'adoption',
                                    value: 'successful',
                                });

                                this.$gtm.dataLayer().push({
                                    event: 'transaction',
                                    ecommerce: {
                                        purchase: {
                                            actionField: {
                                                id: this.$route.params.kravicka_id,
                                                revenue: 1,
                                            },
                                            products: [{
                                                name: 'Kravička',
                                                id: this.$route.params.kravicka_id,
                                                price: 1,
                                                quantity:1
                                            }]
                                        }
                                    }
                                })

                                // achievements ids (3x adopcia)
                                this.achievements(30)
                            }
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },


            // achievements
            achievements(uid) {
                var key = EventService.checkAchievementProgress(this.profil, uid)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, uid)
                        .then(response => {
                            //console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.removeItem("login")
                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },
        }
    }
</script>
